<template>
  <v-card width="1360" class="search_form_wrap">
    <div class="search_form_header d-flex justify-space-between">
      <div class="d-flex align-center">
        <span class="form_title mr-2">{{ title }}</span>
        <i class="icon time"></i>
        <span class="time_info_text mr-1">통계 일시</span>
        <span class="divider mr-1">|</span>
        <span class="time_text">{{ dateTime }}</span>
      </div>
      <button class="d-flex align-center" @click="reset">
        <i class="icon reset mr-1"></i>
        초기화
      </button>
    </div>
    <!--<div class="corps_select_box_wrap">-->
    <!--  <select-box v-model="form.corId" :items="corpsList" placeholder="부대" :format="{ text: 'name', value: 'id' }"></select-box>-->
    <!--</div>-->
    <div class="date_filter_wrap d-flex">
      <date-filter v-model="selectedDate"></date-filter>
      <v-btn color="primaryDark" height="48" class="submit_btn white--text" @click="submit">조회</v-btn>
    </div>
  </v-card>
</template>

<script>
import SelectBox from '@/components/common/SelectBox';
import DateFilter from '@/components/statistics/DateFilter';
import { mapState } from 'vuex';

export default {
  name: 'SearchForm',
  components: {
    SelectBox,
    DateFilter,
  },
  props: {
    title: {
      type: String,
      default: '상태',
    },
  },
  data: () => ({
    dateTime: '',
    form: {
      corId: '',
      startDate: '',
      endDate: '',
    },
    selectedDate: {
      startDate: '',
      endDate: '',
      active: 'All',
    },
  }),
  computed: {
    ...mapState('commonValue', ['corpsList']),
  },
  created() {
    this.todayDateTime();
    Object.assign(this.form, this.$route.query);
    if (this.$route.query.corId) this.form.corId = Number(this.$route.query.corId);
    for (const i in this.selectedDate) {
      if (this.form[i]) {
        this.selectedDate[i] = this.form[i];
      }
    }
  },
  methods: {
    todayDateTime() {
      const today = new Date();
      const date = new Date().toISOString().substr(0, 10);
      const hours = ('0' + today.getHours()).slice(-2);
      const minutes = ('0' + today.getMinutes()).slice(-2);
      this.dateTime = `${this.$convertDateFormat('dot', date)} ${hours}:${minutes}`;
    },
    reset() {
      let self = this;
      Object.keys(this.form).forEach(function (key) {
        self.form[key] = '';
      });
      Object.keys(this.selectedDate).forEach(function (key) {
        self.selectedDate[key] = '';
      });
      this.$emit('reset');
    },
    submit() {
      this.form = Object.assign(this.form, this.selectedDate);
      if (this.selectedDate.active === 'All') delete this.form.active; // 전체인 경우 active 설정 불필요
      this.$emit('search', this.form);
    },
  },
};
</script>

<style scoped></style>
